/**
 * PublicPricingHeader — trimmed-down header rendered on `/pricing` when the
 * visitor is NOT signed in. Removes vault-specific nav (favorites, streak,
 * templates) and shows Sign-in / Get started CTAs instead. Keeps the visual
 * lockup + backdrop-blur styling consistent with the authed Header.
 */
import { Link } from "react-router-dom";

export function PublicPricingHeader() {
  return (
    <header
      className="sticky top-0 z-50 bg-black/85 backdrop-blur-xl border-b border-purple-500/20"
      data-testid="public-pricing-header"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-10 py-3 md:py-4 flex items-center justify-between gap-2">
        <Link to="/" className="flex items-center group" data-testid="public-header-home-link">
          <img
            src="/stag-vault-lockup-v2.webp"
            alt="Stag Vault · AI · Passive Income"
            className="h-9 sm:h-11 md:h-14 w-auto select-none transition-all duration-300 group-hover:drop-shadow-[0_0_16px_rgba(168,85,247,0.55)]"
            style={{
              filter: "drop-shadow(0 0 12px rgba(168, 85, 247, 0.35)) drop-shadow(0 0 4px rgba(176, 112, 255, 0.2))",
            }}
            draggable={false}
            data-testid="public-header-lockup"
          />
        </Link>

        <div className="flex shrink-0 items-center gap-1 sm:gap-3">
          <Link
            to="/playbook"
            className="hidden md:inline-flex items-center gap-2 text-zinc-300 hover:text-purple-300 text-sm tracking-wide px-3 py-2 transition-colors"
            data-testid="public-header-playbook-link"
          >
            Playbook
            <span className="border border-amber-400/50 px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-[0.18em] text-amber-300">New</span>
          </Link>
          <Link
            to="/about"
            className="hidden md:inline-flex text-zinc-300 hover:text-purple-300 text-sm tracking-wide px-3 py-2 transition-colors"
            data-testid="public-header-about-link"
          >
            About
          </Link>
          <Link
            to="/sign-in"
            className="inline-flex min-h-11 items-center whitespace-nowrap text-sm tracking-wide text-zinc-300 hover:text-purple-300 px-2 md:px-4 py-2 transition-colors"
            data-testid="public-header-signin-link"
          >
            Sign in
          </Link>
          <Link
            to="/initiate"
            className="inline-flex min-h-11 items-center gap-2 whitespace-nowrap bg-purple-500 hover:bg-purple-400 text-black px-3 md:px-4 py-2 text-xs tracking-[0.12em] md:tracking-[0.2em] uppercase font-bold transition-all duration-300 shadow-[0_0_14px_rgba(168,85,247,0.45)] hover:shadow-[0_0_24px_rgba(168,85,247,0.8)]"
            data-testid="public-header-getstarted-link"
          >
            Get started
          </Link>
        </div>
      </div>
    </header>
  );
}
